import { MarketingMessageTypes } from "../redux/modules/marketingMessages/selector";

const isMessageMarketingMessage = (message: { type: string }) => {
  return !!message.type && message.type === MarketingMessageTypes.OVERLAY;
};

export default isMessageMarketingMessage;
